/* SoraCare — indicateur de navigation qui glisse vers l'élément survolé,
   + légère ombre sur l'en-tête au défilement.
   Best-effort : n'affecte jamais la navigation elle-même si un sélecteur venait à changer. */
(function () {
  function init() {
    try {
      var links = Array.prototype.slice
        .call(document.querySelectorAll('.menu-list__link'))
        .filter(function (el) {
          return !el.closest('[slot="more"]') && !el.closest('[slot="overflow"]');
        });
      if (!links.length) return;

      var pill = document.createElement('div');
      pill.className = 'soracare-nav-pill';
      pill.setAttribute('aria-hidden', 'true');
      document.body.appendChild(pill);

      var hideTimer;

      function showPillFor(el) {
        clearTimeout(hideTimer);
        var rect = el.getBoundingClientRect();
        pill.style.left = rect.left + 'px';
        pill.style.top = rect.top + rect.height / 2 + 'px';
        pill.style.width = rect.width + 'px';
        pill.style.opacity = '1';
      }

      function hidePill() {
        hideTimer = setTimeout(function () {
          pill.style.opacity = '0';
        }, 60);
      }

      links.forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          showPillFor(el);
        });
        el.addEventListener('focus', function () {
          showPillFor(el);
        });
      });

      var menu = document.querySelector('.header-menu__inner') || document.querySelector('.menu-list');
      if (menu) {
        menu.addEventListener('mouseleave', hidePill);
      }
      window.addEventListener('blur', hidePill);
      window.addEventListener(
        'resize',
        function () {
          pill.style.opacity = '0';
        },
        { passive: true }
      );
      window.addEventListener(
        'scroll',
        function () {
          pill.style.opacity = '0';
        },
        { passive: true }
      );
    } catch (e) {
      /* Silently do nothing — decorative enhancement only. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Ombre légère sur l'en-tête au défilement — sensation d'interface "réactive". */
(function () {
  try {
    var header = document.querySelector('#header-component');
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 8) {
        header.classList.add('soracare-header-scrolled');
      } else {
        header.classList.remove('soracare-header-scrolled');
      }
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  } catch (e) {
    /* Silencieux — amélioration décorative uniquement. */
  }
})();
